import React from 'react'
import RichEmail from '../whitaijiFrontendLibrary/textEditors/RichEmail'

const Emails = () => {
  return (
    <div>
      <RichEmail/>
    </div>
  )
}

export default Emails
